import {
  CheckCircle2,
  CircleDashed,
  CircleDot,
  Eye,
  ListTodo,
  XCircle,
} from 'lucide-react'
import type { StatusPresetMap } from './types'

export type TaskStatus =
  | 'backlog'
  | 'todo'
  | 'in_progress'
  | 'in_review'
  | 'done'
  | 'canceled'

export const taskStatusPresets: StatusPresetMap<TaskStatus> = {
  backlog: { label: 'Backlog', tone: 'neutral', icon: CircleDashed },
  todo: { label: 'Open', tone: 'info', icon: ListTodo },
  in_progress: { label: 'In Progress', tone: 'progress', icon: CircleDot },
  in_review: { label: 'In Review', tone: 'info', icon: Eye },
  done: { label: 'Complete', tone: 'success', icon: CheckCircle2 },
  canceled: { label: 'Canceled', tone: 'critical', icon: XCircle },
}

/**
 * Mental-model groupings for the tasks page. Each tab encodes both an
 * assignee scope (handled at the call site) and a status set:
 *
 * - `plan`: things to schedule — backlog + active work
 * - `todo`: things in flight — open through review
 * - `all`: no status filter (the call site omits `statuses`)
 *
 * `canceled` never appears in a main column — it surfaces only via the
 * kanban drag drop-zone.
 */
export const TASK_STATUS_GROUPS: Record<'plan' | 'todo', TaskStatus[]> = {
  plan: ['backlog', 'todo', 'in_progress', 'in_review'],
  todo: ['todo', 'in_progress', 'in_review'],
}
